export interface AuthIdentity {
  id: string;
  actor_id: string;
  username: string;
  full_name: string;
  role: string;
  role_display_name: string;
  permissions: string[];
  scope: 'all' | 'printing_room' | 'assigned_delivery';
  printing_room: string;
  auth_version: number;
  role_version: number;
  must_change_password: boolean;
}

export function parseIdentity(value: unknown): AuthIdentity {
  const invalid = (): never => { throw new Error('Invalid identity response'); };
  if (!value || typeof value !== 'object' || Array.isArray(value)) return invalid();
  const user = value as Record<string, unknown>;
  const stringField = (key: string, required = false): string => {
    const item = user[key];
    if (typeof item !== 'string' || (required && !item)) return invalid();
    return item;
  };
  const version = (key: string): number => {
    const item = user[key];
    if (typeof item !== 'number' || !Number.isSafeInteger(item) || item < 1) return invalid();
    return item;
  };
  const scope = user.scope;
  if (scope !== 'all' && scope !== 'printing_room' && scope !== 'assigned_delivery') return invalid();
  const printingRoom = stringField('printing_room');
  if (scope === 'printing_room' && !['Printing Room 1', 'Printing Room 2'].includes(printingRoom)) return invalid();
  if (!Array.isArray(user.permissions) || user.permissions.length > 512 ||
    !user.permissions.every(p => typeof p === 'string' && /^[a-z_]+(?:\.[a-z_]+)+$/.test(p))) return invalid();
  if (typeof user.must_change_password !== 'boolean') return invalid();
  const id = stringField('id', true);
  if (!/^[a-f0-9]{24}$/.test(id)) return invalid();
  return {
    id, actor_id: stringField('actor_id', true), username: stringField('username', true),
    full_name: stringField('full_name'), role: stringField('role', true),
    role_display_name: stringField('role_display_name'), permissions: [...user.permissions],
    scope, printing_room: printingRoom, auth_version: version('auth_version'),
    role_version: version('role_version'), must_change_password: user.must_change_password,
  };
}
